function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "99.9880427%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#283A7E",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4790CE",
  offset: "25.8575841%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4790CE",
  offset: "74.2993958%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#337557",
  offset: "99.998007%"
})), /*#__PURE__*/React.createElement("path", {
  id: "path-2",
  d: "M0,0.776842105 L92.1637158,0.776842105 L92.1637158,40 L0,40 L0,0.776842105 Z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "assets-card-icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "production-final",
  transform: "translate(-36.000000, -3643.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "card_cardbleue",
  transform: "translate(36.000000, 3643.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-11",
  fill: "url(#linearGradient-1)",
  x: 0,
  y: 0,
  width: 120,
  height: 80,
  rx: 4
}), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  transform: "translate(14.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-3",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("path", {
  d: "M24.040278,18.7294737 L48.1659885,18.7294737 C47.9508252,13.9736842 46.7357855,9.07052632 43.0505869,5.92105263 C38.6608341,2.16947368 30.9719109,0.777894737 24.1014519,0.777894737 C16.9504369,0.777894737 9.04213151,2.30421053 4.62917476,6.32947368 C0.823737864,9.79684211 0.00105472198,15.3757895 0.00105472198,20.3884211 C0.00105472198,25.6389474 1.61056046,31.7463158 5.73874228,35.2663158 C10.1284951,39.0073684 17.2415402,40.0010526 24.1014519,40.0010526 C30.7651853,40.0010526 37.9837026,38.8789474 42.3481421,35.3252632 C46.699925,31.7757895 48.2039585,25.7968421 48.2039585,20.3884211 L48.2039585,20.3631579 L24.040278,20.3631579 L24.040278,18.7294737 Z",
  id: "Fill-1",
  fill: "#FEFEFE",
  mask: "url(#mask-3)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M49.7087379,20.3968004 L49.7087379,39.223301 L83.2314778,39.223301 L83.2314778,39.1979483 C88.1366279,38.9528721 92.038835,34.9006638 92.038835,29.9251943 C92.038835,24.947612 88.1366279,20.6355384 83.2314778,20.3883495 L83.2314778,20.3968004 L49.7087379,20.3968004 Z",
  id: "Fill-4",
  fill: "#FEFEFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.4563107,10.1965173 C91.4563107,5.39621246 87.6587765,1.59191797 82.8744317,1.59191797 C82.5433863,1.59191797 82.1364323,1.52847782 81.8159297,1.56442724 L49.7087379,1.56442724 L49.7087379,18.8349515 L83.5323055,18.8349515 C87.9687363,18.4521959 91.4563107,14.7409469 91.4563107,10.1965173",
  id: "Fill-6",
  fill: "#FEFEFE"
})))));

function SvgCartesBancaires({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "80px",
    viewBox: "0 0 120 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartesBancaires);
export default __webpack_public_path__ + "static/media/cartesBancaires.f3fa9bda.svg";
export { ForwardRef as ReactComponent };